module.exports = __webpack_public_path__ + "static/media/no-product.2986565a.png";